import { IUser } from "../../../common/types";
import {
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER,
  FETCH_USERS,
  LISTEN_TO_SELECTED_USER,
} from "./userConstants";

const initialState = {
  users: [],
  selectedUser: null,
  lastVisible: null,
  filter: "all",
  startDate: new Date(),
  retainState: false,
};

export default function userReducer(
  state = initialState,
  { type, payload }: any
) {
  switch (type) {
    case CREATE_USER:
      return {
        ...state,
        users: [...state.users, payload],
      };
    case UPDATE_USER:
      return {
        ...state,
        users: [
          ...state.users.filter((evt: IUser) => evt.id !== payload.id),
          payload,
        ],
      };
    case DELETE_USER:
      return {
        ...state,
        users: [...state.users.filter((evt: IUser) => evt.id !== payload)],
      };
    case FETCH_USERS:
      return {
        ...state,
        users: payload,
        moreCities: payload.moreCities,
        lastVisible: payload.lastVisible,
      };
    case LISTEN_TO_SELECTED_USER:
      return {
        ...state,
        selectedUser: payload,
      };

    default:
      return state;
  }
}
